import React from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from './useSEO';

const Success = () => {
  useSEO({
    title: 'Payment successful',
    description: 'Your GCSE or A-Level resource order was successful. Download your past papers, mark schemes, and topic packs.',
    canonicalPath: '/success'
  });

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center p-8 bg-green-50">
      <h1 className="text-4xl font-bold text-green-700 mb-4">Thank you for your purchase!</h1>
      <p className="text-lg text-gray-700 mb-6">
        Your order has been received. We will process it and ship it to you shortly.
      </p>
      <Link
        to="/"
        className="bg-green-600 text-white px-6 py-3 rounded hover:bg-green-700 transition"
      >
        Return to Home
      </Link>
    </div>
  );
};

export default Success;
